/**
 * Created by Jasmine on 2018/1/19.
 */

import { observable, computed, action, autorun, toJS } from "mobx";
import { apis, request } from "../../../utils/net";

const store = observable({
    shopList: [], // 门店列表,
    total: 0,
    page: 1,
    pageSize: 10,

    // 用户可新增总数
    buy_total: 0,

    addData: {}, // 新增门店数据
    editData: {}, // 编辑门店数据
    addVisible: false, // 是否显示新增门店弹框
    editVisible: false, // 是否显示修改门店弹框
    // 获取默认门店数据
    get defualtShopInfo() {
        const item = this.shopList.find(item => item.is_default == 1) || {}
        return item
    },
    // 获取门店列表
    getShopList(p = 1) {
        return request({
            url: apis.getShopList,
            method: "get",
            data: {
                page: p,
                pageSize: this.pageSize
            }
        }).then(res => {
            const { page, store_list, total_count, buy_total } = res;
            this.shopList = store_list;
            this.buy_total = buy_total;
            this.page = page;
            this.total = total_count;

            // 新增门店时，默认填充“默认门店”的数据
            for (let k in store_list) {
                // is_default，1 默认门店，0 非默认门店
                if (store_list[k].is_default == 1) {
                    let arr = store_list[k].region_code.split("");

                    this.addData = {
                        ...store_list[k],
                        // 省市区处理，3个长度编码数组
                        areas: [
                            arr[0] + arr[1] + "0000", arr[0] + arr[1] + arr[2] + arr[3] + "00", store_list[k].region_code
                        ]
                    }
                }
            }
        })
    },

    addShop(data) {
        return request({ url: apis.addShop, method: 'post', data })
    },

    editShop(data) {
        return request({ url: apis.editShop, method: 'post', data })
    },

    //停止使用二维码
    stopCode(parameter) {
        request({
            url: apis.setStoreQrcode,
            method: 'post',
            data: parameter
        }).then(res => {
            // 刷新列表
            this.getShopList()
        });
    },

    //删除新增门店
    deleteStores(parameter) {
        request({
            url: apis.setStoreDel,
            method: 'post',
            data: {'id': parameter}
        }).then(res => {
            // 刷新列表
            this.getShopList()
        });
    },
});

export default store;
